// Version : 0.0.1
// Author : SABARI

/* eslint-disable import/no-anonymous-default-export */
import MemberMandatoryAccessActionTypes from './member-mandatory-access.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Fetch Mandatory Member Access Response
	fetchMandatoryMemberAccessResponse: null,

	// Fetch Mandatory Member Access Arrary
	fetchMandatoryMemberAccessArr: [],

	//Update Mandatory Member Access Response
	updateMandatoryMemberAccessResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_SUCCESS:
			return {
				...state,
				fetchMandatoryMemberAccessResponse: action.payload,
				fetchMandatoryMemberAccessArr: docodeHexResponse(
					action.payload,
					'MemberMandatoryAccessKey',
				),
			};

		case MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_FAILURE:
			return {
				...state,
				fetchMandatoryMemberAccessResponse: action.payload,
				fetchMandatoryMemberAccessArr: [],
			};

		case MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_RESPONSE_CHANGED:
			return {
				...state,
				fetchMandatoryMemberAccessResponse: null,
			};

		case MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_SUCCESS:
			return {
				...state,
				updateMandatoryMemberAccessResponse: action.payload,
			};

		case MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_FAILURE:
			return { ...state, updateMandatoryMemberAccessResponse: action.payload };

		case MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_RESPONSE_CHANGED:
			return {
				...state,
				updateMandatoryMemberAccessResponse: null,
			};
		default:
			return state;
	}
};
